export class ShiftCodeReq {

    shiftCode: string;

    constructor(shiftCode: string) {
        this.shiftCode = shiftCode;
    }
}